<template>
  <div class="category-main-app">
    <common-desktop-element v-if="isMainPage" class="category-main-app__menu-wrapper vn-grid-medium">
      <category-menu class="category-main-app__menu" :categoryList="menu" />
    </common-desktop-element>
    <div v-else class="category-main-app__menu-wrapper vn-grid-medium">
      <category-menu class="category-main-app__menu" :categoryList="menu" />
    </div>
    <template v-for="category in list">
      <div v-if="category" :key="category.id">
        <div class="category-header vn-grid-medium">
          <h5 class="category-title">{{ category.title }}</h5>
          <a v-if="category.courses.length > DISPLAYING_LIMIT" class="category-link-all" :href="category.slug">
            전체보기 >
          </a>
        </div>
        <course-card-carousel :courseList="category.courses" class="vn-grid-medium vn-grid-medium-carousel" />
      </div>
    </template>
  </div>
</template>

<script>
import CommonDesktopElement from '../../common/desktop-element.vue';
import CategoryMenu from '../components/category-menu.vue';
import CourseCardCarousel from '../components/course-card-carousel';

import { DISPLAYING_LIMIT } from '../shared';

export default {
  components: { CommonDesktopElement, CategoryMenu, CourseCardCarousel },
  props: {
    menu: {
      type: Array,
    },
    list: {
      type: Array,
    },
  },

  data() {
    return {
      isMainPage: location.pathname === '/',
      DISPLAYING_LIMIT,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../components/category-main.scss';

$bold: 700;
.category-main-app {
  margin-bottom: 8rem;
  padding-top: 7.9rem;

  &__menu {
    margin: 0 auto 8rem;
  }

  .category {
    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 6.4rem;
      margin-bottom: 2rem;
      @include mobile {
        margin-top: 4.8rem;
        margin-bottom: 1.6rem;
      }
    }
    &-title {
      font-weight: $bold;
      font-size: 2rem;
      color: #171717;
      line-height: 3rem;
      @include mobile {
        font-size: 1.8rem;
      }
    }
    &-link-all {
      font-weight: 700;
      font-size: 1.6rem;
      color: #757575;
      line-height: 2.6rem;
      text-decoration-line: underline;
      @include mobile {
        font-size: 1.4rem;
      }
    }
  }

  @include mq($until: $large) {
    padding-top: 4rem;

    &__menu-wrapper {
      padding: 0;
    }

    &__menu {
      margin: 0 auto 4.8rem;
    }
  }
}

.vn-grid-medium-carousel {
  @include tablet {
    padding: 0;
  }
}
</style>
